module.exports = __webpack_public_path__ + "img/product-placeholder-21.7460190.png";